var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigmaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.541,
    height: 52,
    viewBox: "0 0 36.541 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15768",
    "data-name": "Group 15768",
    transform: "translate(-237.236 -297.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15767",
    "data-name": "Group 15767",
    transform: "translate(237.236 297.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19673",
    "data-name": "Path 19673",
    d: "M240.6,330.95c-4.192-4.306-4.719-10.6-.011-15.587a10.633,10.633,0,0,1-3.178-6.049c-.86-6.208,3.169-11.644,9.4-11.992,5.817-.324,11.674-.232,17.5.014,4.158.176,7.08,2.617,8.622,6.449a10.066,10.066,0,0,1-1.748,10.663c-.243.3-.505.588-.8.925,3.848,4.366,4.637,9.092,1.241,14.013-2.815,4.079-6.984,4.964-13.431,3.153,0,2,0,3.979,0,5.954,0,5.265-3.825,9.864-8.729,10.509-5.65.743-10.423-2.313-11.851-7.685C236.558,337.334,237.759,333.924,240.6,330.95Zm12.063-2.726v-10.1c-1.82,0-3.551-.083-5.271.019a5.038,5.038,0,0,0,.114,10.064C249.183,328.286,250.87,328.224,252.659,328.224Zm-.012-15.566V302.576c-1.745,0-3.389-.083-5.02.018a5.159,5.159,0,0,0-4.98,5.134,5.066,5.066,0,0,0,4.605,4.915C249.018,312.715,250.789,312.658,252.647,312.658Zm5.591.006c1.772,0,3.447.019,5.121,0a5.032,5.032,0,0,0,4.907-4.463c.313-2.187-1.241-4.847-3.476-5.278a51.692,51.692,0,0,0-6.552-.463Zm-5.5,21.017c-1.84,0-3.518-.021-5.2,0a5.059,5.059,0,0,0-4.893,4.888,5.214,5.214,0,0,0,4.922,5.188,5.108,5.108,0,0,0,5.142-4.5C252.835,337.461,252.736,335.65,252.736,333.681Zm5.462-10.533a5.1,5.1,0,0,0,4.978,5.081,5.057,5.057,0,1,0,.047-10.113A5.1,5.1,0,0,0,258.2,323.148Z",
    transform: "translate(-237.236 -297.114)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogo);
export default __webpack_public_path__ + "static/media/figma-logo.2b62a82dbebe0219f1f63fd3ad621724.svg";
export { ForwardRef as ReactComponent };